import React from 'react';
import { Card, Fade, Stack, Typography } from '@mui/material';
import { ReceiptLong, ShoppingCart } from '@mui/icons-material';

// Cuando no hay pedido seleccionado (columnas de detalle de la lista)
export const EmptyOrderState = () => (
    <Fade in={true} timeout={800}>
        <Stack
            component={Card}
            flex={1}
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            spacing={2}
            p={4}
        >
            <Stack
                width={100}
                height={100}
                borderRadius="50%"
                bgcolor="grey.200"
                justifyContent="center"
                alignItems="center"
            >
                <ReceiptLong sx={{ fontSize: 48, color: 'grey.400' }} />
            </Stack>
            <Typography variant="h5" fontWeight={600} color="text.secondary" gutterBottom>
                No hay pedido seleccionado
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 400, mb: 4 }}>
                Selecciona un pedido de la lista para ver los detalles y gestionarlo
            </Typography>
        </Stack>
    </Fade>
);

// Componente para mostrar cuando no hay pedidos en la lista
export const EmptyListState = () => (
    <Fade in={true} timeout={800}>
        <Stack flex={1} alignItems="center" justifyContent="center" textAlign="center" spacing={2}>
            <Stack
                width={100}
                height={100}
                borderRadius="50%"
                bgcolor="grey.200"
                justifyContent="center"
                alignItems="center"
            >
                <ShoppingCart sx={{ fontSize: 48, color: 'grey.400' }} />
            </Stack>
            <Typography variant="h6" color="text.secondary">
                No hay pedidos disponibles
            </Typography>
            <Typography variant="body2" color="text.secondary">
                Los pedidos aparecerán aquí cuando sean creados
            </Typography>
        </Stack>
    </Fade>
);
